import { css } from 'styled-components';

const margin = css `
  margin: ${props => props.$margin};
`;
const marginTop = css `
  margin-top: ${props => props.$marginTop};
`;
const marginRight = css `
  margin-right: ${props => props.$marginRight};
`;
const marginBottom = css `
  margin-bottom: ${props => props.$marginBottom};
`;
const marginLeft = css `
  margin-left: ${props => props.$marginLeft};
`;

export { margin, marginBottom, marginLeft, marginRight, marginTop };
//# sourceMappingURL=margin.js.map
